import React from 'react';
import { useSpc } from '../context/SpcContext';

export function SCInfoContent() {
  return (
    <div className="sc-info" data-testid="sc-info-modal">
      <p className="sc-info-eyebrow">Smart Performance Coaching · Member information</p>
      <h3 className="sc-info-h1">STRONGER FOR<br /><span>THE LONG RUN.</span></h3>
      <p className="sc-info-intro">
        Welcome to your SPC Strength &amp; Conditioning block. Coached by <strong>Darren and Alex</strong>, these sessions
        will help you build strength, stability, balance and agility to support your endurance sport.
      </p>
      <div className="sc-info-facts">
        <span>LOCATION: EASY GARAGE · HR4 9UN</span>
        <span>COACHES: DARREN &amp; ALEX</span>
        <span>YOUR S&amp;C BLOCK</span>
      </div>
      <section className="sc-info-attendance">
        <h4>Booked in? We're expecting you.</h4>
        <p>
          You are automatically marked as attending the sessions in your booked block.{' '}
          <strong>You only need to update your attendance if you cannot make a session.</strong>
        </p>
        <ol>
          <li>Open the <strong>Club app</strong>.</li>
          <li>Find the S&amp;C session you cannot attend.</li>
          <li><strong>Untick yourself / remove your attendance</strong> for that session.</li>
        </ol>
        <p>
          Please do this as soon as you know. An accurate attendance list helps us plan the exercises, equipment and
          coaching to suit the group coming along. If you have trouble updating it, let Darren or Alex know.
        </p>
      </section>
      <div className="sc-info-grid">
        <section className="sc-info-card">
          <span className="sc-info-num">01 / FIND US</span>
          <h4>Your pop-up gym</h4>
          <p>Our pop-up gym is located <strong>within Easy Garage, HR4 9UN</strong>.</p>
          <p>Check your booked session in the Club app for the date and start time. Aim to arrive <strong>5–10 minutes early</strong>, ready to begin the warm-up together.</p>
          <p>As we are based within a working garage, follow the coaches' directions and stay within the designated training area.</p>
          <a className="sc-info-map" href="https://www.google.com/maps/search/?api=1&query=Easy+Garage+HR4+9UN" target="_blank" rel="noopener noreferrer">Find Easy Garage on Google Maps ↗</a>
        </section>
        <section className="sc-info-card">
          <span className="sc-info-num">02 / THE FOCUS</span>
          <h4>Strength that supports your sport</h4>
          <p>Throughout the block, Darren and Alex will work with you on overall strength, movement control, stability, balance, coordination and agility.</p>
          <p>Expect coached exercises that support the demands of running, cycling, swimming and other endurance activities. We will adapt exercises and loads to your experience and ability.</p>
          <p><strong>Good technique comes first.</strong> Build confidence, move well and progress at the right level for you.</p>
        </section>
        <section className="sc-info-card">
          <span className="sc-info-num">03 / YOUR KIT</span>
          <h4>Bring the essentials</h4>
          <ul>
            <li><strong>A towel</strong> — you'll probably earn it.</li>
            <li><strong>A drink</strong> — bring your own water bottle.</li>
            <li><strong>Comfortable training clothing</strong> that lets you move freely.</li>
            <li><strong>Clean, supportive trainers</strong> suitable for gym exercises.</li>
            <li><strong>A sense of humour</strong> — effort is expected; laughing is encouraged.</li>
          </ul>
        </section>
        <section className="sc-info-card">
          <span className="sc-info-num">04 / BEFORE WE START</span>
          <h4>Keep your coaches in the loop</h4>
          <p>Tell Darren or Alex about any injuries, pain, health changes or movement limitations before the session. Also let us know if you are unusually tired or carrying fatigue from a race or demanding training.</p>
          <p>Take part in the warm-up and follow the coaching instructions. If an exercise causes pain or you feel unwell, stop and speak to a coach so we can adjust the session.</p>
          <p>No need to arrive already strong or knowing every exercise. <strong>That's what we're here for.</strong></p>
        </section>
      </div>
      <p className="sc-info-finish">Bring the effort.<br /><span>We'll bring the coaching.</span></p>
    </div>
  );
}

export function ScInfoBadge({ testId, className }) {
  const { openModal } = useSpc();
  return (
    <button
      type="button"
      className={`sc-alert-badge ${className || ''}`}
      data-testid={testId || 'sc-info-badge'}
      onClick={(e) => { e.stopPropagation(); openModal('scInfo'); }}
      title="Important S&C block info — tap to read"
      aria-label="Important S&C block info — tap to read"
    >
      !
    </button>
  );
}
